export interface UserEarlyAccessResponse {
    id: string;
  
    firstName: string;
    lastName: string;
    companyName: string;
    email: string;
  
    role: string;
    platformRole: string;
    annualLeadershipHiringVolume: string;
    linkedInUrl: string;
  
    foundingMember2026: boolean;
    leadershipNetworkContributor: boolean;
  
    status: string;
  
    createdAt: string;
    updatedAt: string;
  }


  export const initialUserEarlyAccessResponse: UserEarlyAccessResponse = {
    id: "",
  
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
  
    role: "",
    platformRole: "",
    annualLeadershipHiringVolume: "",
    linkedInUrl: "",
  
    foundingMember2026: false,
    leadershipNetworkContributor: false,
  
    status: "",
  
    createdAt: "",
    updatedAt: "",
  };